import { Link } from 'react-router-dom';
import { rankingComics } from '@/mocks/comics';

export default function RankingSection() {
  const top10 = rankingComics.slice(0, 10);

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            人气排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-1">根据阅读量和评分综合排序</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {top10.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 p-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full font-heading font-bold text-sm flex-shrink-0 ${
                index < 3
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-secondary-200 text-secondary-700'
              }`}>
                {index + 1}
              </div>
              <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors duration-200">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">
                  {comic.author} · {comic.category}
                </p>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-star-fill text-accent-500 text-[10px] mr-0.5"></i>
                    {comic.rating}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {(comic.views / 10000).toFixed(1)}万人气
                  </span>
                </div>
              </div>
              <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap flex-shrink-0 ${
                comic.status === '连载中'
                  ? 'bg-accent-100 text-accent-700'
                  : 'bg-secondary-100 text-secondary-700'
              }`}>
                {comic.status}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}